import { NearMeIcon } from "components/icons"
import { Button, useTheme } from "@mui/material"
import { useMemo } from "react"

import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"

export const StartButton = ({ label = "Start", ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const icon = useMemo(
    () => getIcon(theme?.assets?.navigation?.start) || <NearMeIcon />,
    [theme]
  )

  return (
    <Button variant="contained" startIcon={icon} {...props}>
      {t(label)}
    </Button>
  )
}
